module.exports = __webpack_public_path__ + "img/basketball-category-icon-white.abe9e6b0.png";